/* eslint-disable no-undef */
// userSaga.js
import { call, put, takeEvery } from 'redux-saga/effects';
import { healthRecordImageRequestError, healthRecordImageRequestSuccess, healthRecordRequestError, healthRecordRequestSuccess, healthRecordTypesRequestError, healthRecordTypesRequestSuccess, healthRecordTypesUploadError, healthRecordTypesUploadSuccess } from './Actions';
import axios from 'axios';
import { HEALTH_REC_TYPES, HEALTH_REC_UPLOAD, HEALTH_RECORD_REQUEST, RECORD_IMAGE_OPEN } from './Constants';
import { Modal } from 'antd';



function* getHeathRecord(action) {

    try {    

        let pageNo = action.page;
        if (pageNo == null) {
            pageNo = 1;
        }
        const skip = (pageNo - 1) * 12;

        const urll = `${process.env.REACT_APP_API_BASE_URL}/healthrecordscount`;

        let headers ={
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        const response1 = yield call(axios.get, urll,{ headers});

        const url = `${process.env.REACT_APP_API_BASE_URL}/healthrecordsnew`;
  
        // // Example headers - You can add more headers as per your requirement
        headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            limit: 12,
            skip: skip,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        // // const data = {};  // Data you want to send with the POST request (can be empty for a simple POST)
  

        const response = yield call(axios.get, url,{ headers});

        // // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            
            // Dispatch the success action with data and message      
            yield put(healthRecordRequestSuccess(response.data, response1 && response1.data[0] && response1.data[0].total));
        } else {
            // Dispatch the failure action with the response message
            yield put(healthRecordRequestError('An error occurred.'));
        }
    } catch (error) {
        
        yield put(healthRecordRequestError('An error occurred.'));
        // throw error;
    // yield put(fetchUserFailure(error));
    }

}

function* healthrecImage(action) {

    try {    
        
        const url = action.url;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        const response = yield call(axios.get, url,{ headers, responseType: 'blob'});
        if (response.status === 200 || response.status === 201) {            
            const blob = URL.createObjectURL(response.data);
            window.open(blob);  
            yield put(healthRecordImageRequestSuccess(response.data));
        } else {
            yield put(healthRecordImageRequestError('An error occurred.'));
        }

    } catch (error) {
        
        yield put(healthRecordImageRequestError('An error occurred.'));
    }

}

function* healthrecTypes() {

    try {    
        
        const url = `${process.env.REACT_APP_API_BASE_URL}/healthrectype`;
  
        // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
        // // const data = {};  // Data you want to send with the POST request (can be empty for a simple POST)
  

        const response = yield call(axios.get, url,{ headers});

        // // Check if the response is successful
        if (response.status === 200 || response.status === 201) {
            
            // Dispatch the success action with data and message      
            yield put(healthRecordTypesRequestSuccess(response.data));
        } else {
            // Dispatch the failure action with the response message
            yield put(healthRecordTypesRequestError('An error occurred.'));
        }

    } catch (error) {
        
        yield put(healthRecordTypesRequestError('An error occurred.'));
        // throw error;
    // yield put(fetchUserFailure(error));
    }
}

function* healthrecordNewUpload(action) {

    try {    

        const patientId = sessionStorage.getItem('PATIENT_ID');
        const userId = sessionStorage.getItem('USER_ID');
        
        const formdata = new FormData();
        formdata.append('file',  action.values.payload.file);
        formdata.append('patientsid', patientId);
        formdata.append('healthrectype',  action.values.payload.selectValue);
        formdata.append('organisationsid', 1);
        formdata.append('usersid', userId);
        formdata.append('createdByOrgId', 1);
        
        const data = formdata;
        
        
        const url = `${process.env.REACT_APP_API_BASE_URL}/healthrecupload`;
  
        // // // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
  
  
        const response = yield call(axios.post, url, data, { headers});

        if (response.status === 201) {
            Modal.success({
                title: 'Health Record Uploaded Successfully',
            });
            yield put(healthRecordTypesUploadSuccess('success'));
            // yield put(push('/record'));
        } else if (response.status === 403) {
            Modal.warning({
                title: 'No file selected',
            });
            yield put(healthRecordTypesUploadError('An error occurred.'));
            // yield put({ type: HEALTH_REC_UPLOAD_FAILED });
        }

    } catch (error) {
        
        yield put(healthRecordTypesUploadError('An error occurred.'));
        // throw error;
    // yield put(fetchUserFailure(error));
    }
}

// Watcher Saga
export function* watchFetchHealthRecords() {
    yield takeEvery(HEALTH_RECORD_REQUEST, getHeathRecord);
    yield takeEvery(RECORD_IMAGE_OPEN, healthrecImage);
    yield takeEvery(HEALTH_REC_TYPES, healthrecTypes);
    yield takeEvery(HEALTH_REC_UPLOAD, healthrecordNewUpload);
}
